import * as React from 'react';
import type {
    CalendarSurfaceStore,
    CalendarSurfaceTransformProps,
    ColumnItemsProvider,
    SurfaceItem,
} from 'owa-calendar-surface-dategrid';
import { observer } from 'mobx-react-lite';
import {
    getAllowedResizeTypesForRegularItem,
    getAllowedResizeTypesForAllDayItem,
    makeDraggable,
    allDayDragHelperTemplate,
    dayWeekDragHelperTemplate,
} from 'owa-calendar-surface-dategrid-common-dnd';
import { renderAsAllDay } from 'owa-calendar-types';
import { DayGrid, DayGridProps } from 'owa-day-grid-core';

function customDragElementDecorator(
    store: CalendarSurfaceStore,
    config: CalendarSurfaceTransformProps,
    element: JSX.Element,
    groupIndex: number,
    item: SurfaceItem
): JSX.Element {
    if (store.enableDragDrop) {
        let allowedResizeTypes = renderAsAllDay(item.model)
            ? getAllowedResizeTypesForAllDayItem(store, config.dragDropConfig, item.model)
            : getAllowedResizeTypesForRegularItem(
                  store,
                  config.dragDropConfig,
                  item.model,
                  config.columnProvider.getColumnDate.bind(config.columnProvider),
                  groupIndex
              );
        return makeDraggable(store, config.dragDropConfig, item, element, allowedResizeTypes);
    } else {
        return element;
    }
}

function createCustomDragElements(
    store: CalendarSurfaceStore,
    config: CalendarSurfaceTransformProps,
    columnItemsProvider: ColumnItemsProvider,
    isAllDay: boolean
): JSX.Element[] {
    if (store.enableDragDrop) {
        if (isAllDay) {
            return [allDayDragHelperTemplate(store, config, columnItemsProvider.allDayRows)];
        } else {
            return [dayWeekDragHelperTemplate(store, config)];
        }
    }
    return [];
}

/**
 * Day grid component
 */
export default observer(function DraggableDayGrid(props: DayGridProps) {
    return (
        <DayGrid
            {...props}
            customElementDecorator={customDragElementDecorator}
            createCustomElements={createCustomDragElements}
        />
    );
});
